import React, { useEffect } from 'react'
import { Form, Picker } from 'antd-mobile'
import { cooperationInfo, natureInfo } from './config'
import API from '../../../../../server/index'

const initialValues = {
  cooperation: ['1'],
  nature: ['1'],
}
const basicInfoData = [...cooperationInfo['1'], ...natureInfo['1']]
const cooperationColumns = [
  [
    { label: '直播推广', value: '1' },
    { label: '供应商', value: '2' },
    { label: '短视频推广', value: '3' },
  ],
]
const natureColumns = [
  [
    { label: '生产厂商', value: '1' },
    { label: '品牌商', value: '2' },
    { label: '经销商', value: '3' },
    { label: '代理商', value: '4' },
    { label: '其他', value: '5' },
  ],
]

export default function Information() {
  const [form] = Form.useForm()
  const [basicInfo, setBasicInfo] = React.useState(basicInfoData)
  const [moreInfo, setMoreInfo] = React.useState<any[]>([])
  const [categoryColumns, setCategoryColumns] = React.useState<any>([])

  const getSelectDataSource = async () => {
    const res: any = await API.NewSupplierCategoryCategoryNo36890({
      categoryNo: '0',
    })
    let array: any[] = []
    if (Array.isArray(res?.list)) {
      array =
        res.list.map((item: any) => {
          const { categoryNo, categoryName } = item
          return {
            ...item,
            value: categoryNo,
            label: categoryName,
          }
        }) ?? []
      setCategoryColumns([array])
    }
  }

  const clickHeight = ()=>{
    window.parent.postMessage({
      height: '100vh',
      type: "height",
    }, "*");
  }
  const clickCancel = ()=>{
    const height = window?.document.getElementById("root")?.clientHeight
    window.parent.postMessage({
      height,
      type: "height",
    }, "*");
  }

  const onConfirm = async (value: any) => {
    let category: string = value[0]
    let categoryList: any[] = categoryColumns[0]
    let arr: any = []
    arr = categoryList.filter((item: any) => item.categoryNo === category)
    const res: any = await API.CategoryNo60874({
      mainCategoryPathList: arr,
    })

    if (res) {
      const list = res.list || []
      let data: any = []
      list.map((item: any) => {
        const { qualificationName, qualificationDesc } = item
        if (qualificationName) {
          data.push({
            name: qualificationName,
            desc: qualificationDesc || '-',
          })
        }
      })

      setMoreInfo(data)
    }
  }

  const onFormLayoutChange = (value: any) => {
    if (
      value &&
      (Object.keys(value).includes('cooperation') ||
        Object.keys(value).includes('nature'))
    ) {
      const cooperationVal: any = form.getFieldValue('cooperation')
      const natureVal = form.getFieldValue('nature')
      const data1: any = cooperationInfo[cooperationVal[0]]
      const data2: any = natureInfo[natureVal[0]]

      setBasicInfo([...data1, ...data2])
    }
  }

  const TableComponent = (props: any) => {
    const { item } = props
    const { name, desc } = item
    return (
      <div className="table-item-wrapper">
        <div className="first-child">
          <div className="info-name">{name}</div>
        </div>
        <div className="second-child">
          <div className="desc">{desc}</div>
        </div>
      </div>
    )
  }

  const handleValue = (value: any) => {
    return value && value.length ? value[0]?.label : '请选择'
  }

  useEffect(() => {
    getSelectDataSource()
  }, [])

  return (
    <div className="information-wrapper">
      <Form
        form={form}
        name="basic"
        initialValues={initialValues}
        layout="horizontal"
        onValuesChange={onFormLayoutChange}
        style={{
          '--border-top': 'none',
          '--border-bottom': 'none',
        }}
      >
        <Form.Item
          label="合作方式："
          name="cooperation"
          trigger="onConfirm"
          onClick={(e, PickerRef: any) => {
            PickerRef.current?.open()
            clickHeight()
          }}
        >
          <Picker columns={cooperationColumns} onClose={clickCancel}>{handleValue}</Picker>
        </Form.Item>
        <Form.Item
          label="公司性质："
          name="nature"
          trigger="onConfirm"
          onClick={(e, PickerRef: any) => {
            PickerRef.current?.open()
            clickHeight()
          }}
        >
          <Picker columns={natureColumns} onClose={clickCancel}>{handleValue}</Picker>
        </Form.Item>
        <Form.Item
          label="品牌类目："
          name="category"
          trigger="onConfirm"
          onClick={(e, PickerRef: any) => {
            PickerRef.current?.open()
            clickHeight()
          }}
        >
          <Picker columns={categoryColumns} onConfirm={onConfirm} onClose={clickCancel}>
            {handleValue}
          </Picker>
        </Form.Item>
      </Form>
      <div className="title">所需材料清单</div>
      <div className="sub-title">基础资质材料</div>
      {basicInfo.map((item, index) => {
        return <TableComponent item={item} key={`table_component_${index}`} />
      })}
      {moreInfo && moreInfo.length > 0 && (
        <>
          <div className="sub-title">商品资质材料</div>
          {moreInfo.map((item, index) => {
            return (
              <TableComponent item={item} key={`table_component_${index}`} />
            )
          })}
        </>
      )}
    </div>
  )
}
